import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import "jalaali-react-date-picker/lib/styles/index.css";

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import store from './store';


import "./index.css"
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <CacheBuster
    currentVersion={packageInfo.version}
    isVerboseMode={false} 
    isEnabled={true}
    metaFileDirectory={'.'} 
  >
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </CacheBuster>

);

